import { render, staticRenderFns } from "./set-password.vue?vue&type=template&id=34c4bf6e&scoped=true"
import script from "./set-password.vue?vue&type=script&lang=js"
export * from "./set-password.vue?vue&type=script&lang=js"
import style0 from "./set-password.vue?vue&type=style&index=0&id=34c4bf6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c4bf6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c4bf6e')) {
      api.createRecord('34c4bf6e', component.options)
    } else {
      api.reload('34c4bf6e', component.options)
    }
    module.hot.accept("./set-password.vue?vue&type=template&id=34c4bf6e&scoped=true", function () {
      api.rerender('34c4bf6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/set-password-view-renderer/set-password.vue"
export default component.exports